﻿import { createSlice, createAsyncThunk  } from "@reduxjs/toolkit";

// Thunk para logout
export const logoutThunk = createAsyncThunk('auth/logoutThunk', async (_, { dispatch }) => {
  dispatch(logoutUser());
});

const userEmptyState = {
  userdata: {},
  tokenuser: ""
};

export const userSlice = createSlice({
  name: "user",
  initialState: userEmptyState,
  reducers: {
    loginUser: (state, action) => action.payload,
    TokenUser: (state, action) => {
      state.tokenuser = action.payload;
    },
    logoutUser: () => userEmptyState,
  },
});

// Action creators are generated for each case reducer function
export const { loginUser, TokenUser, logoutUser } = userSlice.actions;

export default userSlice.reducer;
